import {
  Flex,
  Checkbox,
  CheckboxGroup,
  Stack,
  Input,
  Text,
} from "@chakra-ui/react";
import { useParams } from "react-router-dom";
import { UseFormReturn } from "react-hook-form";
import { StoreClientForm } from "../../../components/templates/StoreClient";
import { Form } from "../../../components/atoms/Form";
import { PrivacityText } from "../../../components/atoms/Text/PrivacityText";
import { SubmitButton } from "../../../components/atoms/Button/SubmitButton";
import { useFormClient } from "../../../hooks/formClient";
import { TitleDefault } from "../../../components/atoms/Text/TitleDefault";
import { SubtitleDefault } from "../../../components/atoms/Text/SubtitleDefault";
import { SearchSimpleLink } from "../../../components/molecules/SearchSimpleLink";
import { HTMLText } from "../../../components/atoms/Div/HTMLText";

interface IProps {
  handle: (data: any) => void;
  form: UseFormReturn<any>;
}

export function StoreClientOnePage({ handle, form }: IProps) {
  const { search, company } = useFormClient();
  const { answer_id } = useParams();
  const { register, handleSubmit, formState } = form;

  const { errors } = formState;

  return (
    <>
      <TitleDefault title="Cadastro" />
      <SubtitleDefault
        subtitle={
          search.title
            ? search.title
            : `Pesquisa de Satisfação - ${company.name}`
        }
      />
      {search.skip_registration_decision && (
        <HTMLText html={search.client_message} />
      )}
      <Stack spacing={2}>
        <Form id="store-client" onSubmit={handleSubmit(handle)}>
          <StoreClientForm
            default_country={company.default_country}
            has_cpf={company.collect_cpf}
            bg={company.color}
            register={register}
            errors={errors}
            has_cnpj={search.has_cnpj ?? false}
            is_totem={search.is_totem}
          />
          {company.has_fidelity_confirmation ? (
            <CheckboxGroup>
              <Flex alignItems="start" justify="start" flexDir="column" my={1}>
                <Checkbox
                  {...register("fidelity")}
                  isRequired={false}
                  variant=""
                >
                  <Text
                    color="#626262"
                    fontSize="14px"
                    fontWeight="18px"
                    w="100%"
                    textAlign="start"
                  >
                    Aceito participar do Programa de Fidelidade
                  </Text>
                </Checkbox>
              </Flex>
            </CheckboxGroup>
          ) : (
            <></>
          )}
          <CheckboxGroup>
            <Flex alignItems="start" justify="start" flexDir="column">
              <Checkbox {...register("approved")} isRequired={true} variant="">
                <PrivacityText link={company.privacy_policy_link} />
              </Checkbox>
            </Flex>
            <Input required={true} type="hidden" />
          </CheckboxGroup>
        </Form>
      </Stack>

      <Flex
        justify={!search.unique_answer_client ? "space-between" : "flex-end"}
        alignItems="center"
      >
        {!search.unique_answer_client && (
          <SearchSimpleLink
            link={`/formularios/${company.slug}/${
              search.slug
            }/cliente/atualizar${answer_id ? "/" + answer_id : ""}`}
            text="Já sou cadastrado"
          />
        )}
        <SubmitButton
          bg={company.color}
          color="white"
          text="Cadastrar"
          form="store-client"
          isLoading={formState.isSubmitting}
        />
      </Flex>
    </>
  );
}
